// Refresh token geçersiz olduğunda oturumu tek seferde sonlandırır
// (mobildeki SessionManager'ın web karşılığı). Aynı anda başarısız olan
// birden çok istek forceLogout çağırsa bile token temizliği ve login
// yönlendirmesi yalnızca bir kez yapılır.
//
// React tarafında global navigator olmadığı için AuthContext, mount olunca
// kendi logout handler'ını registerLogoutHandler ile kaydeder; böylece
// forceLogout React state'ini temizleyip yönlendirme yapabilir. Handler
// kayıtlı değilse window.location ile login'e düşülür.

import { clearTokens } from './tokenStorage';

let loggingOut = false;
let logoutHandler = null;

export const registerLogoutHandler = (handler) => {
  logoutHandler = handler;
};

export const forceLogout = () => {
  if (loggingOut) return;
  loggingOut = true;
  clearTokens();
  if (logoutHandler) {
    logoutHandler();
  } else {
    window.location.assign('/login');
  }
};

// Yeni bir oturum kurulduğunda (login veya başarılı refresh) çağrılır.
export const resetSession = () => {
  loggingOut = false;
};
